import * as React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import './SelectColumnModal.scss'
import Select, { components } from 'react-select';
import { getLabTestCategoryList, getQueryReport, getLabTestList } from '../../../../../redux/actions/AnalyticalReportAction/QueryReportAction';
import { parseJSON } from '../../../../../utils/Helper';
import { ReactComponent as DeleteIcon } from "../../../../../assets/images/CommonComponent/redCross.svg"
import { ReactComponent as DragIcon } from "../../../../../assets/images/CommonComponent/drag.svg"
import { DROPDOWN, JSON_TYPE } from '../../../../../Config/Constant';
import DraggableComponent from '../../../../../components/DraggableComponent/DraggableComponent';
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { createSearchParams, useNavigate, useSearchParams } from 'react-router-dom';
import { ANALYTICAL_REPORT } from '../../../../../Router/RoutesURL';
import Button from '../../../../../components/Button/Button';
import CancelButton from '../../../../../components/Button/CancelButton';
import { useDispatch, useSelector } from 'react-redux';

const generateSubOptionslabel = (item, level = 1) => {
  let s = item?.[`nested_data_level${level}`]?.sub_category;
  if (!s)
    return ''
  return ` \n----> ${s} ${generateSubOptionslabel(item, level + 1)}`
}


function findIfAllSubOptionsSelected(data, columns, level = 0, key) {
  if (!columns || columns.length === 0) return false;
  if (typeof data === 'string' || typeof data === 'number') {
    return columns.some(item =>
      (item.selected_json_key != null && String(item.selected_json_key) === String(data)) ||
      item.selected_json_key_label === key ||
      item?.[`nested_data_level${level - 1}`]?.sub_category === key
    );
  }
  if (!Array.isArray(data)) {
    if (key && columns.some(item =>
      item.selected_json_key_label === key ||
      item?.[`nested_data_level${level - 1}`]?.sub_category === key
    )) {
      return true;
    }
    return false;
  }

  // Empty array = sub-options not yet fetched (API not called), so nothing is selected
  if (data.length === 0) return false;

  return data.every((item) => {
    if (!item) return true;
    const itemName = item.sub_category || item.label || item.value;
    const itemHasSub = hasSubOptions(item);

    if (itemHasSub) {
      const childColumns = columns.filter(e =>
        e?.[`nested_data_level${level}`]?.sub_category === itemName
      );
      return findIfAllSubOptionsSelected(item.json_key, childColumns, level + 1, itemName);
    }

    // Leaf item
    return columns.some(col => {
      if (item.json_key != null && col.selected_json_key != null) {
        return (
          String(col.selected_json_key) === String(item.json_key) &&
          (!col[`nested_data_level${level}`] ||
            col[`nested_data_level${level}`]?.sub_category === itemName)
        );
      }
      return (
        col[`nested_data_level${level}`]?.sub_category === itemName ||
        col.selected_json_key_label === itemName
      );
    });
  });
}

const hasSubOptions = (item) => {
  if (!item) return false;
  if (item.data_type === JSON_TYPE) return true;
  if (Array.isArray(item.json_key) && item.json_key.length > 0) return true;
  return false;
};

const collectLeafColumns = (item, baseColumn, currentLevel) => {
  if (!item) return [];
  const isLeaf = !hasSubOptions(item);
  const subCategoryName = item.sub_category || item.label || item.value;
  const currentStepData = {
    sub_category: subCategoryName,
    data_type: item.data_type,
    json_key: item.json_key,
    id: item.id,
  };

  const updatedBase = {
    ...baseColumn,
    data_type: item.data_type,
    [`nested_data_level${currentLevel}`]: currentStepData,
    selected_json_key_label: Array.isArray(item.json_key) ? '' : subCategoryName,
    selected_json_key: Array.isArray(item.json_key) ? '' : item.json_key,
  };

  if (isLeaf) {
    return [updatedBase];
  }

  let leaves = [];
  if (Array.isArray(item.json_key)) {
    item.json_key.forEach((subItem) => {
      leaves = leaves.concat(collectLeafColumns(subItem, updatedBase, currentLevel + 1));
    });
  }
  return leaves;
};

const isColumnAlreadySelected = (colToCheck, existingColumns) => {
  if (!colToCheck || !existingColumns?.length) return false;
  return existingColumns.some((existing) => {
    if (existing.label !== colToCheck.label || existing.tableLabel !== colToCheck.tableLabel) {
      return false;
    }
    if (existing.column_name && colToCheck.column_name && existing.column_name !== colToCheck.column_name) {
      return false;
    }
    if (existing.extra_key && colToCheck.extra_key && existing.extra_key !== colToCheck.extra_key) {
      return false;
    }
    if (colToCheck.selected_json_key != null && existing.selected_json_key != null) {
      if (String(existing.selected_json_key) !== String(colToCheck.selected_json_key)) {
        return false;
      }
      let lvl = 1;
      while (colToCheck[`nested_data_level${lvl}`]) {
        if (existing[`nested_data_level${lvl}`]?.sub_category !== colToCheck[`nested_data_level${lvl}`]?.sub_category) {
          return false;
        }
        lvl++;
      }
      return true;
    }
    if (existing.selected_json_key_label === colToCheck.selected_json_key_label) {
      let lvl = 1;
      while (colToCheck[`nested_data_level${lvl}`]) {
        if (existing[`nested_data_level${lvl}`]?.sub_category !== colToCheck[`nested_data_level${lvl}`]?.sub_category) {
          return false;
        }
        lvl++;
      }
      return true;
    }
    return false;
  });
};


const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '50%',
  height: '480px',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 3,
  pb: 2
};


export default function SelectColumnModal({ openModal, setOpenModal }) {
  const dispatch = useDispatch()
  const [menuOpen, setMenuOpen] = React.useState(false);
  const [searchParams, setSearchParams] = useSearchParams()
  const data = useSelector(state => state?.queryReportReducer);
  let localData = parseJSON(localStorage.getItem('query')) || {}
  const [columns, setColumns] = React.useState(localData?.columns || [])
  const [currentColumn, setCurrentColumn] = React.useState({})
  const [pendingSelectAllLabTest, setPendingSelectAllLabTest] = React.useState(false);
  const wasLoadingLabTest = React.useRef(false);
  const boxRef = React.useRef(null);
  const prevColumnsLength = React.useRef(localData?.columns?.length || 0);
  const navigate = useNavigate();

  const activeCategory = data?.keysCategoryList?.find(c => c.category === currentColumn?.tableLabel);
  const activeSub = activeCategory?.sub_category?.find(s => (s.sub_category_alias || s.sub_category_title) === currentColumn?.label);
  const currentJsonKey = activeSub?.json_key || currentColumn?.json_key;

  const handleClose = () => setOpenModal(false);

  React.useEffect(() => {
    if (openModal) {
      let ld = parseJSON(localStorage.getItem('query')) || {};
      const initialCols = ld?.columns || [];
      setColumns(initialCols);
      prevColumnsLength.current = initialCols.length;
      setCurrentColumn({});
      setPendingSelectAllLabTest(false);
      wasLoadingLabTest.current = false;
    }
  }, [openModal]);

  React.useEffect(() => {
    if (data?.loadingLabTestCategoryList) {
      wasLoadingLabTest.current = true;
    }
    if (pendingSelectAllLabTest && wasLoadingLabTest.current && !data?.loadingLabTestCategoryList) {
      wasLoadingLabTest.current = false;
      const activeCat = data?.keysCategoryList?.find(c =>
        c.category === currentColumn?.tableLabel ||
        c.category === "Lab Test" ||
        c.category === "Patient Lab Test"
      );
      const activeSubCat = activeCat?.sub_category?.find(s =>
        s.column_name === "lab_test_static_fields_json" ||
        s.for_unique_key_alias === "lab_t_s_f_" ||
        s.sub_category_alias === "Lab Report Parameters" ||
        s.sub_category_title === "Lab Static Fields" ||
        (s.sub_category_alias || s.sub_category_title) === currentColumn?.label
      );
      const categories = activeSubCat?.json_key;

      if (Array.isArray(categories) && categories.length > 0) {
        let allLeaves = [];
        categories.forEach((item) => {
          const leaves = collectLeafColumns(item, currentColumn, 1);
          allLeaves = allLeaves.concat(leaves);
        });

        if (allLeaves.length > 0) {
          setColumns((prevCols) => {
            const toAdd = allLeaves.filter((col) => !isColumnAlreadySelected(col, prevCols));
            return toAdd.length > 0 ? [...prevCols, ...toAdd] : prevCols;
          });
        }
        setCurrentColumn({});
      }
      setPendingSelectAllLabTest(false);
    }
  }, [pendingSelectAllLabTest, data?.loadingLabTestCategoryList, data?.keysCategoryList, currentColumn]);

  const handleColumnChange = (e) => {
    if (e?.isDisabled) return;
    const isLab =
      e.column_name === "lab_test_static_fields_json" ||
      e.for_unique_key_alias === "lab_t_s_f_" ||
      e.tableLabel === "Lab Test" ||
      e.tableLabel === "Patient Lab Test" ||
      e.label === "Lab Report Parameters" ||
      e.label === "Lab Static Fields";

    setCurrentColumn(prev => {
      let d = {
        label: e.label,
        data_type: e.data_type,
        table: e.table,
        tableLabel: e.tableLabel,
        table_name_alias: e.table_name_alias,
        json_key: e.json_key,
        selected_json_key_label: e.sub_category_title,
        selected_json_key: e.json_key,
        column_name: e.column_name,
        for_unique_key_alias: e.for_unique_key_alias,
        row_id: e.row_id,
        extra_key: e.extra_key,
      };
      if (e.data_type !== JSON_TYPE) {
        setColumns(prev => ([...prev, d]))
      } else {
        setMenuOpen(false)
        return d;
      }
    });
  }


  const handleAdd = () => {
    let getData = parseJSON(localStorage.getItem('query'))
    getData = {
      condition: getData?.condition || 'or',
      filter: getData?.filter || []
    }
    localStorage.setItem('query', JSON.stringify({ ...getData, columns }));

    let columnExist = false;
    columns?.forEach((item) => {
      let key = item.selected_json_key ? `${item.for_unique_key_alias}${item.selected_json_key}` : (item?.for_unique_key_alias || item.column_name)
      if (key === searchParams.get("orderBy")) {
        columnExist = true;
      }
    })
    if (searchParams.get("orderBy") && !columnExist) {
      searchParams.delete('orderBy')
      searchParams.delete('orderByType')
      navigate({
        pathname: `${ANALYTICAL_REPORT}`,
        search: `?${createSearchParams([...searchParams.entries()])}`,
      }, { replace: true })
    } else {
      dispatch(getQueryReport({
        ...getData, columns,
        page: searchParams.get("page") ? parseInt(searchParams.get("page")) + 1 : 1,
        pageLimit: searchParams.get("pageLimit") || 50,
        orderBy: columnExist ? searchParams.get("orderBy") : '',
        orderByType: columnExist ? searchParams.get("orderByType") : '',
      }))
    }
    setOpenModal(false)
  }

  const handleDelete = (index) => {
    setColumns(prev => {
      let data = [...prev]
      data.splice(index, 1);
      return data;
    })
  }

  const handleResetColumns = () => {
    setColumns(prev => prev.filter(col => col.can_delete === false));
    setCurrentColumn({});
  };

  const hasDeletableColumns = Boolean(columns?.some(col => col.can_delete !== false));

  React.useEffect(() => {
    if (boxRef.current && (columns?.length || 0) > prevColumnsLength.current) {
      boxRef.current.scrollTop = boxRef.current.scrollHeight;
    }
    prevColumnsLength.current = columns?.length || 0;
  }, [columns])

  return (
    <div>
      <Modal
        sx={{
          ".MuiBox-root": {
            border: "none", borderRadius: "10px", outline: "none"
          }
        }}
        open={openModal}
        className='customized-scrollbar'
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className="select-column-modal h-100 d-flex flex-column">
            <div className="d-flex justify-content-between align-items-center">
              <div className="title">Select Columns To View in Table</div>
              <button
                type="button"
                className="reset-btn"
                disabled={!hasDeletableColumns}
                onClick={handleResetColumns}
              >
                Reset
              </button>
            </div>
            <div className="hr mb-3"></div>
            <div className="d-flex flex-grow-1">
              <div>
                <CustomSelect
                  menuOpen={menuOpen}
                  setMenuOpen={setMenuOpen}
                  isSearchable={true}
                  isLoading={data?.loadingKeys}
                  value={currentColumn?.label ? { label: currentColumn?.label, value: `${currentColumn?.tableLabel}-${currentColumn?.label}` } : null}
                  placeholder={"Select Column"}
                  onChange={handleColumnChange}
                  options={data?.keysCategoryList?.map(category => ({
                    label: category.category,
                    value: category.category,
                    options: category.sub_category.map(sub => {
                      const subLabel = sub.sub_category_alias || sub.sub_category_title;
                      const isSubJson = sub.data_type === JSON_TYPE || Array.isArray(sub.json_key);
                      const subColumns = columns.filter(
                        e => (e.label === subLabel || e.label === sub.sub_category_title) &&
                          (e.tableLabel ? e.tableLabel === category.category : e.table === sub.table) &&
                          (!sub.column_name || !e.column_name || e.column_name === sub.column_name) &&
                          (!sub.extra_key || !e.extra_key || e.extra_key === sub.extra_key)
                      );

                      return {
                        label: subLabel,
                        value: `${category.category}-${subLabel}`,
                        tableLabel: category.category,
                        table: sub.table,
                        table_name_alias: sub.table_name_alias,
                        data_type: sub.data_type,
                        column_name: sub.column_name,
                        json_key: sub.json_key,
                        for_unique_key_alias: sub.for_unique_key_alias,
                        row_id: sub.row_id,
                        extra_key: sub.extra_key,
                        sub_category_title: sub.sub_category_title,
                        isDisabled: isSubJson
                          ? findIfAllSubOptionsSelected(sub?.json_key, subColumns, 1)
                          : subColumns.length > 0
                      };
                    })
                  }))}
                />
                {
                  (currentJsonKey || currentColumn?.json_key) &&
                  <RecursiveSelect
                    json={currentJsonKey || currentColumn?.json_key}
                    currentColumn={currentColumn}
                    columns={columns.filter(e => e.label === currentColumn?.label && e.tableLabel === currentColumn.tableLabel)}
                    setCurrentColumn={setCurrentColumn}
                    setColumns={setColumns}
                    pendingSelectAllLabTest={pendingSelectAllLabTest}
                    setPendingSelectAllLabTest={setPendingSelectAllLabTest}
                  />
                }
              </div>

              <div ref={boxRef} className=" mb-3 flex-grow-1 overflow-y-scroll ml-3 border p-2 rounded column-list-box" style={{ height: '330px' }} >
                {/* {
                     groupedData(columns)?.map((item, index)=>{
                        return (
                              <div className='col-block' key={index}>
                                  
                                  <div>
                                      {
                                        item.data?.map((subCategory, subIndex)=>{
                                              return (
                                                  <div className='ml-2 p-1 shadow-sm my-2 d-flex flex-column justify-content-center' key={subIndex} >
                                                      <div className='d-flex align-items-center'>
                                                        <DragIcon className='cursor-pointer flex-shrink-0 mr-2' fontSize={'16px'} /> 
                                                        <div className="label flex-shrink-0 ">{item?.label} - </div>
                                                      </div>
                                                      <div className='d-flex justify-content-between'>
                                                        <div className="">{subCategory.label} {generateSubOptionslabel(subCategory, 1)} </div>
                                                        <DeleteIcon onClick={()=>{handleDelete(subCategory.index)}} className='cursor-pointer flex-shrink-0' width={'14px'} />
                                                      </div>
                                                  </div>
                                              )
                                          })
                                      }
                                  </div>
                              </div>
                          )
                      }) 
                  } */}

                <DraggableComponent
                  data={columns?.map((item, index) => ({ ...item, id: index }))}
                  setData={setColumns}
                  component={<>
                    {columns.map((col, index) => (
                      <Column key={index} item={{ ...col, id: index, handleDelete }} />
                    ))}
                  </>}
                />

              </div>
            </div>
            <div className='d-flex mt-3 justify-content-center'>
              <Button
                className='py-1 rounded-lg'
                text={'Show Selected Columns'}
                onClick={handleAdd}
              />
              <CancelButton
                className='py-1 rounded-lg'
                text={'Cancel'}
                onClick={handleClose}
              />
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
}


const RecursiveSelect = ({
  json,
  currentColumn,
  columns,
  setCurrentColumn,
  setColumns,
  level = 1,
  pendingSelectAllLabTest,
  setPendingSelectAllLabTest,
}) => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state?.queryReportReducer);
  const [menuOpen, setMenuOpen] = React.useState(false);

  const isLabTest =
    currentColumn?.column_name === "lab_test_static_fields_json" ||
    currentColumn?.for_unique_key_alias === "lab_t_s_f_" ||
    currentColumn?.tableLabel === "Patient Lab Test" ||
    currentColumn?.tableLabel === "Lab Test" ||
    currentColumn?.label === "Lab Report" ||
    currentColumn?.label === "Lab Report Parameters" ||
    currentColumn?.label === "Lab Static Fields";

  if (!json || typeof json === 'string' || !Array.isArray(json))
    return null;

  const isLeafSelected = (item) => {
    return Boolean(
      columns?.some((col) => {
        if (item.json_key != null && col.selected_json_key != null) {
          return (
            String(col.selected_json_key) === String(item.json_key) &&
            (!col[`nested_data_level${level}`] ||
              col[`nested_data_level${level}`]?.sub_category === (item.sub_category || item.label))
          );
        }
        return (
          col[`nested_data_level${level}`]?.sub_category === (item.sub_category || item.label) ||
          col.selected_json_key_label === (item.sub_category || item.label)
        );
      })
    );
  };

  const handleSelectAll = () => {
    setMenuOpen(false);

    if (isLabTest && level === 1) {
      const isAlreadyLoaded = Boolean(
        data?.isLabTestListLoaded ||
        (Array.isArray(json) && json.some((cat) => Array.isArray(cat?.json_key) && cat?.json_key?.length > 0))
      );

      if (!isAlreadyLoaded) {
      }
      dispatch(getLabTestCategoryList({ isTestList: true }));
      setPendingSelectAllLabTest?.(true);
      return;
    }

    let allLeaves = [];

    json.forEach((item) => {
      const leaves = collectLeafColumns(item, currentColumn, level);
      allLeaves = allLeaves.concat(leaves);
    });

    if (allLeaves.length > 0) {
      setColumns((prevCols) => {
        const toAdd = allLeaves.filter((col) => !isColumnAlreadySelected(col, prevCols));
        return toAdd.length > 0 ? [...prevCols, ...toAdd] : prevCols;
      });
    }

    setCurrentColumn((prev) => {
      const allUpdatedCols = [
        ...columns,
        ...allLeaves.filter((col) => !isColumnAlreadySelected(col, columns)),
      ];
      const isEntireColumnCompleted = findIfAllSubOptionsSelected(
        currentColumn?.json_key,
        allUpdatedCols,
        1
      );

      if (level === 1 || isEntireColumnCompleted) {
        return {};
      }
      const updated = { ...prev };
      let lvl = level - 1;
      while (updated[`nested_data_level${lvl}`]) {
        delete updated[`nested_data_level${lvl}`];
        lvl++;
      }
      updated.selected_json_key = '';
      updated.selected_json_key_label = '';
      return updated;
    });
  };

  const handleSubCategoryChange = (e) => {
    if (e?.isDisabled) return;
    if (e?.isSelectAll || e?.value === '__SELECT_ALL__') {
      handleSelectAll();
      return;
    }


    if (isLabTest && level === 1) {
      dispatch(getLabTestList({
        isStatic: 1,
        cat_id: e.id,
        cat_name: e.label,
        nested_data_level1: { sub_category: e.label }
      }));
    }

    const hasSub = hasSubOptions(e);

    if (hasSub) {
      setCurrentColumn((prev) => ({
        ...prev,
        data_type: e.data_type,
        [`nested_data_level${level}`]: {
          sub_category: e.label,
          data_type: e.data_type,
          json_key: e.json_key,
          id: e.id,
        },
        selected_json_key_label: '',
        selected_json_key: '',
      }));
      setMenuOpen(false);
      return;
    }

    // Leaf option
    let d = {
      ...currentColumn,
      data_type: e.data_type,
      [`nested_data_level${level}`]: {
        sub_category: e.label,
        data_type: e.data_type,
        json_key: e.json_key,
        id: e.id,
      },
      selected_json_key_label: e.label,
      selected_json_key: e.json_key,
    };

    let updatedCols = columns;
    if (!isColumnAlreadySelected(d, columns)) {
      updatedCols = [...columns, d];
      setColumns((prevCols) => {
        if (!isColumnAlreadySelected(d, prevCols)) {
          return [...prevCols, d];
        }
        return prevCols;
      });
    }

    const areAllOptionsSelected = Array.isArray(json) && json.every((item) => {
      const hasSubChild = hasSubOptions(item);
      if (hasSubChild) {
        return findIfAllSubOptionsSelected(
          item?.json_key,
          updatedCols?.filter((col) => col[`nested_data_level${level}`]?.sub_category === (item?.sub_category || item?.label)),
          level + 1,
          item.sub_category || item.label
        );
      }
      return isColumnAlreadySelected(
        {
          ...currentColumn,
          data_type: item.data_type,
          [`nested_data_level${level}`]: {
            sub_category: item.sub_category || item.label,
            data_type: item.data_type,
            json_key: item.json_key,
            id: item.id,
          },
          selected_json_key_label: item.sub_category || item.label,
          selected_json_key: item.json_key,
        },
        updatedCols
      );
    });

    if (areAllOptionsSelected) {
      setMenuOpen(false);
      setCurrentColumn((prev) => {
        const isEntireColumnCompleted = findIfAllSubOptionsSelected(
          currentColumn?.json_key,
          updatedCols,
          1
        );

        if (level === 1 || isEntireColumnCompleted) {
          return {};
        }

        const updated = { ...prev };
        let lvl = level - 1;
        while (updated[`nested_data_level${lvl}`]) {
          delete updated[`nested_data_level${lvl}`];
          lvl++;
        }
        updated.selected_json_key = '';
        updated.selected_json_key_label = '';
        return updated;
      });
    }
  };

  const itemOptions = Array.isArray(json)
    ? json.map((item) => {
      const hasSub = hasSubOptions(item);
      const isDisabled = hasSub
        ? findIfAllSubOptionsSelected(
          item?.json_key,
          columns?.filter((e) => e[`nested_data_level${level}`]?.sub_category === (item?.sub_category || item?.label)),
          level + 1,
          item.sub_category || item.label
        )
        : isLeafSelected(item);

      return {
        label: item.sub_category || item.label,
        value: item.sub_category || item.label,
        json_key: item.json_key,
        data_type: item.data_type,
        id: item.id,
        isDisabled: Boolean(isDisabled),
      };
    })
    : [];

  let options = itemOptions;
  if (Array.isArray(json) && json.length > 0) {
    const allSelected = itemOptions.length > 0 && itemOptions.every((opt) => opt.isDisabled);
    const selectAllOption = {
      label: '--- Select All ---',
      value: '__SELECT_ALL__',
      isSelectAll: true,
      isDisabled: allSelected,
    };
    options = [selectAllOption, ...itemOptions];
  }

  const cleanStr = (s) => String(s || '').trim().toLowerCase().replace(/[^a-z0-9]/g, '');
  const selectedLevelData = currentColumn[`nested_data_level${level}`];
  const selectedName = selectedLevelData?.sub_category || selectedLevelData?.label;
  const selectedId = selectedLevelData?.id;

  const foundItem = Array.isArray(json)
    ? json.find((it) =>
      (selectedId != null && it.id != null && String(it.id) === String(selectedId)) ||
      (selectedName && (it.sub_category === selectedName || it.label === selectedName)) ||
      (selectedName && it.sub_category && cleanStr(it.sub_category) === cleanStr(selectedName))
    )
    : null;

  const childJsonKey = (foundItem?.json_key?.length ? foundItem.json_key : null) ||
    (selectedLevelData?.json_key?.length ? selectedLevelData.json_key : foundItem?.json_key) ||
    selectedLevelData?.json_key;

  return (
    <>
      {
        Array.isArray(json) &&
        <div className='mt-2'>
          <CustomSelect
            menuOpen={menuOpen}
            setMenuOpen={setMenuOpen}
            isSearchable={true}
            isLoading={Boolean(
              (isLabTest && level === 1 && (data?.loadingLabTestCategoryList || pendingSelectAllLabTest)) ||
              (isLabTest && level === 2 && data?.loadingLabTestList)
            )}
            value={currentColumn[[`nested_data_level${level}`]]?.sub_category ? { label: currentColumn[[`nested_data_level${level}`]]?.sub_category, value: currentColumn[[`nested_data_level${level}`]]?.json_key } : null}
            options={options}
            placeholder='Select'
            onChange={handleSubCategoryChange}
          />
        </div>
      }
      <RecursiveSelect
        json={childJsonKey}
        currentColumn={currentColumn}
        columns={columns?.filter((item) => item[`nested_data_level${level}`]?.sub_category === currentColumn[`nested_data_level${level}`]?.sub_category)}
        setCurrentColumn={setCurrentColumn}
        setColumns={setColumns}
        level={level + 1}
        pendingSelectAllLabTest={pendingSelectAllLabTest}
        setPendingSelectAllLabTest={setPendingSelectAllLabTest}
      />
    </>
  );
};

export const Column = ({ item }) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id: item.id });
  const draggingStyle = isDragging ? { opacity: 1, backgroundColor: '#f8f9fa' } : {};

  const style = {
    transform: CSS.Translate.toString(transform),
    backgroundColor: 'white',
    ...draggingStyle
  };

  return (
    <div className='ml-2 p-1 shadow-sm my-2 d-flex flex-column justify-content-center outline-none' style={style} ref={setNodeRef}>
      <div className='d-flex align-items-center'>
        <DragIcon

          {...listeners}
          className='cursor-pointer flex-shrink-0 mr-2 outline-none'
          fontSize={'16px'} />
        <div className="label flex-shrink-0 ">{item?.tableLabel} - </div>
      </div>
      <div className='d-flex justify-content-between ml-4'>
        <div className="">{item.label} {generateSubOptionslabel(item, 1)} </div>
        {!(item.can_delete === false) && <span><span className='bg-light rounded p-1 pt-0 mb-1'><DeleteIcon onClick={() => { item?.handleDelete(item.id) }} className='cursor-pointer flex-shrink-0' width={'14px'} /></span></span>}
      </div>
    </div>
  );
};


// Custom event used so that opening one select closes all others
const OPEN_EVENT = 'custom-select-opened';

const CustomSelect = ({ menuOpen, setMenuOpen, options, isSearchable, isLoading, value, onChange, placeholder, styles = {} }) => {
  const [input, setInput] = React.useState("")
  const selectRef = React.useRef(null);
  // Unique identifier for this instance — stable across renders
  const selectId = React.useRef(Symbol('select')).current;

  // Broadcast to all other CustomSelect instances that this one is opening
  const handleOpen = React.useCallback(() => {
    document.dispatchEvent(new CustomEvent(OPEN_EVENT, { detail: selectId }));
    setMenuOpen(true);
  }, [selectId, setMenuOpen]);

  React.useEffect(() => {
    // Close this select when a DIFFERENT select opens
    const handleOtherOpen = (e) => {
      if (e.detail !== selectId) {
        setMenuOpen(false);
      }
    };
    // Close on outside click
    const handleClickOutside = (event) => {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener(OPEN_EVENT, handleOtherOpen);
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener(OPEN_EVENT, handleOtherOpen);
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [selectId, setMenuOpen]);

  React.useEffect(() => {
    if (value) {
      setInput("")
    }
  }, [value])

  const CustomOption = (props) => {
    const ref = React.useRef();

    React.useEffect(() => {
      props.isSelected && ref.current.scrollIntoView();
    }, [props.isSelected]);

    return (
      <components.Option {...props} innerRef={ref} />
    );
  };

  const CustomDropdownIndicator = (props) => {
    const { menuOpen, setMenuOpen, onOpen } = props;
    return (
      <div
        onMouseDown={(e) => {
          e.preventDefault();
          e.stopPropagation();
          // Toggle: if already open just close, otherwise open (broadcasts to close others)
          if (menuOpen) setMenuOpen(false);
          else onOpen();
        }}
        style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
      >
        <components.DropdownIndicator {...props} />
      </div>
    );
  };

  return (
    <div ref={selectRef}>
      <Select
        styles={{
          option: (base, state) => ({
            ...base,
            whiteSpace: 'pre',
            ...(state.isDisabled && {
              color: '#aaa !important',
              cursor: 'not-allowed !important',
            }),
            ...(state.data?.isSelectAll && {
              fontWeight: 600,
              borderBottom: '1px solid #e0e0e0',
              color: state.isDisabled ? '#aaa !important' : '#74613C',
            }),
          }),
          singleValue: (base) => ({ ...base, whiteSpace: 'pre' }),
          ...styles,
        }}
        isOptionDisabled={(option) => Boolean(option?.isDisabled)}
        className="select-column-modal-select"
        classNamePrefix="select"
        isSearchable={isSearchable}
        name="color"
        isLoading={isLoading}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        options={options}
        menuIsOpen={menuOpen}
        onMenuOpen={handleOpen}
        onMenuClose={() => setInput("")}
        closeOnMenuSelect={false}
        blurInputOnSelect={false}
        menuShouldScrollIntoView={false}
        components={{
          DropdownIndicator: (props) => (
            <CustomDropdownIndicator {...props} menuOpen={menuOpen} setMenuOpen={setMenuOpen} onOpen={handleOpen} />
          ),
          Option: CustomOption
        }}
        inputValue={input}
        onInputChange={(value, actionMeta) => {
          if (actionMeta.action === "input-change") {
            setInput(value);
          }
        }}
      />
    </div>
  );
};

